import { PathBase } from "@constellation-academy/epic-ui";

export class OrderEditPath extends PathBase {
	static readonly pathKey = "edit";
}
